<template>
  <div class="overview-bar">
    <div class="overview-bar__header">
      <h4>{{ title }}</h4>
      <span>{{ data && data.length ? '最近趋势' : '暂无数据' }}</span>
    </div>
    <div class="overview-bar__canvas">
      <v-chart
        height="254"
        :data="data"
        :forceFit="true"
        :padding="['auto', 'auto', '40', '50']"
      >
        <v-tooltip />
        <v-axis />
        <v-bar position="x*y" color="#4d8ac5" />
      </v-chart>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bar',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    scale: {
      type: Array,
      default: () => {
        return [
          {
            dataKey: 'x',
            min: 2
          },
          {
            dataKey: 'y',
            title: '时间',
            min: 1,
            max: 22
          }
        ];
      }
    },
    tooltip: {
      type: Array,
      default: () => {
        return [
          'x*y',
          (x, y) => ({
            name: x,
            value: y
          })
        ];
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
.overview-bar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.overview-bar__header h4 {
  margin: 0;
  color: #1f3147;
  font-size: 16px;
  font-weight: 700;
}

.overview-bar__header span {
  color: #6b8198;
  font-size: 12px;
  font-weight: 600;
}

.overview-bar__canvas {
  padding: 14px 16px 8px;
  border-radius: 22px;
  background:
    radial-gradient(circle at top right, rgba(174, 213, 235, 0.16), transparent 32%),
    linear-gradient(180deg, rgba(251, 253, 255, 0.98) 0%, rgba(243, 248, 252, 0.96) 100%);
  border: 1px solid rgba(120, 146, 176, 0.12);
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Bar.vue